<template>
  <div class="inactive-student-widget">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <span class="badge badge-warning text-white mr-2 p-1 font-size-12">
          <i class="fe fe-user-x"></i> Inactive
        </span>
        <h6 class="mb-0 font-weight-bold text-dark">Inactive & Exited</h6>
      </div>
      <div class="text-right">
        <span class="font-size-24 font-weight-bold text-warning">{{ inactiveCount || 0 }}</span>
        <span class="text-muted font-size-12 ml-1">Students</span>
      </div>
    </div>

    <!-- Multi-segment distribution progress bar -->
    <div class="progress mt-2 mb-3" style="height: 6px; background-color: #e9ecef;">
      <div
        class="progress-bar bg-warning"
        role="progressbar"
        :style="{ width: tcPercent + '%' }"
        :title="'TC Issued: ' + (inactiveTcCount || 0)"
      ></div>
      <div
        class="progress-bar bg-danger"
        role="progressbar"
        :style="{ width: abscondPercent + '%' }"
        :title="'Absconded: ' + (inactiveAbscondCount || 0)"
      ></div>
      <div
        class="progress-bar bg-secondary"
        role="progressbar"
        :style="{ width: otherPercent + '%' }"
        :title="'Others: ' + (inactiveOtherCount || 0)"
      ></div>
    </div>

    <div class="row no-gutters text-center border-top pt-2">
      <div class="col-4 border-right pr-1">
        <div class="font-size-12 text-muted mb-1">TC Issued</div>
        <div class="badge badge-light-warning text-warning font-weight-bold font-size-14 px-2 py-1">
          {{ inactiveTcCount || 0 }}
        </div>
      </div>
      <div class="col-4 border-right px-1">
        <div class="font-size-12 text-muted mb-1">Absconded</div>
        <div class="badge badge-light-danger text-danger font-weight-bold font-size-14 px-2 py-1">
          {{ inactiveAbscondCount || 0 }}
        </div>
      </div>
      <div class="col-4 pl-1">
        <div class="font-size-12 text-muted mb-1">Others</div>
        <div class="badge badge-light-secondary text-secondary font-weight-bold font-size-14 px-2 py-1">
          {{ inactiveOtherCount || 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeoInactiveStudentCard',
  props: {
    inactiveCount: {
      type: [Number, String],
      default: 0,
    },
    inactiveTcCount: {
      type: [Number, String],
      default: 0,
    },
    inactiveAbscondCount: {
      type: [Number, String],
      default: 0,
    },
    inactiveOtherCount: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    totalInactive() {
      return Number(this.inactiveCount) || 0
    },
    tcPercent() {
      if (this.totalInactive > 0) {
        return Math.round(((Number(this.inactiveTcCount) || 0) / this.totalInactive) * 100)
      }
      return 0
    },
    abscondPercent() {
      if (this.totalInactive > 0) {
        return Math.round(((Number(this.inactiveAbscondCount) || 0) / this.totalInactive) * 100)
      }
      return 0
    },
    otherPercent() {
      if (this.totalInactive > 0) {
        return Math.round(((Number(this.inactiveOtherCount) || 0) / this.totalInactive) * 100)
      }
      return 0
    },
  },
}
</script>

<style scoped>
.inactive-student-widget {
  width: 100%;
}
.badge-light-warning {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
}
.badge-light-danger {
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
}
.badge-light-secondary {
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
}
</style>
